import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import firebaseMessagingService from '../services/FirebaseMessagingService';

/**
 * No-UI manager (same pattern as VersionCheckManager) that uploads this
 * device's FCM token to the backend once the user is logged in — without
 * this, the backend never learns the token FirebaseMessagingService already
 * obtained, and can only ever push to the shared "all_users" topic, never to
 * one specific account.
 */
export default function DeviceTokenRegistrar() {
  const { isAuthenticated, authFetch } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    firebaseMessagingService.registerWithBackend(authFetch);
  }, [isAuthenticated, authFetch]);

  return null;
}
